import { Linking, Platform } from 'react-native';
import Toast from 'react-native-toast-message';

/**
 * Linking.openURL rejects with "Unable to open URL: <url>" when no app handles
 * the scheme — no mail app installed, SMS unavailable, restricted device, etc.
 * That's an expected device state, not a bug. Centralized catch + toast so
 * these never reach Sentry. See CHURCH-APP-1CR / CHURCH-APP-1CW.
 */
export const openURL = (url) => {
    if (!url) return Promise.resolve();
    return Linking.openURL(url).catch(() => {
        Toast.show({ type: 'error', text2: 'Unable to open that on this device.' });
    });
};

/**
 * Opens a tappable link from user content (chat messages, posts, notes).
 * http(s) links open in the in-app webview on native / new tab on web;
 * other schemes (mailto:, tel:, sms:) go straight to the OS.
 */
export const openHyperlink = (url, router) => {
    if (/^https?:\/\//i.test(url || '')) {
        if (Platform.OS === 'web') {
            window.open(url, '_blank');
        } else {
            router.push({ pathname: '/(utilities)/webview', params: { url } });
        }
    } else {
        openURL(url);
    }
};
